import {
  ActionLogAction,
  ActionLogTrigger,
  ActionLogResult,
  ActionLogObjectType,
} from '@birco/rainmesh-api';
import { ApiFilters } from '../../../core/models/interfaces/api-filters.interface';
import { format, subMonths } from 'date-fns';

export const FEATURE_NAME = 'actionLogState';

export interface ActionLogState {
  entities: Record<string, any>; // Cache for the actual objects
  error: any | null;
  isLoading: boolean;
  filter: ActionLogFilter;
  pages: Record<number, string[]>; // Page number to ids on that page
  totalCount: number;
}

export type ActionLogSortBy = 'eventDate' | 'action' | 'objectName' | 'result';
export type ActionLogSortDir = 'asc' | 'desc';

export interface ActionLogFilter extends ApiFilters {
  startDate?: string;
  endDate?: string;
  actions?: ActionLogAction[];
  triggers?: ActionLogTrigger[];
  result?: ActionLogResult;
  objectTypes?: ActionLogObjectType[];
  userEmail?: string;
  sortBy?: ActionLogSortBy;
  sortDir?: ActionLogSortDir;
}

const today = new Date();

export const initialState: ActionLogState = {
  entities: {},
  filter: {
    page: 0,
    pageSize: 12,
    startDate: format(subMonths(today, 1), 'yyyy-MM-dd'),
    endDate: format(today, 'yyyy-MM-dd'),
    sortBy: 'eventDate',
    sortDir: 'desc',
  },
  pages: {},
  totalCount: 0,
  isLoading: false,
  error: null,
};
